import { type UseQueryResult, useQuery } from 'react-query';
import {
  LongShareService,
  LongShareSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_LongShareService_ParticipantLongSharesListDto,
} from '../../services/wealthlane-award-services';

const useGetParticipantAllLongShares = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  type?: 'RSU' | 'ESOP' | 'PSU' | 'ESPP' | 'Inbound'
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_LongShareService_ParticipantLongSharesListDto[] | undefined,
  unknown
> => {
  const participantLongShares = useQuery(
    ['getParticipantLongShares'],
    async () => {
      return await handleRequest(
        LongShareSharedService.getApiAwardApiAppLongShareParticipantLongSharesList('')
      );
    }
    // {
    //   enabled: type === 'RSU',
    // }
  );

  return participantLongShares;
};

export default useGetParticipantAllLongShares;
